import AD from './flags/ad.svg';
import AE from './flags/ae.svg';
import AF from './flags/af.svg';
import AG from './flags/ag.svg';
import AI from './flags/ai.svg';
import AL from './flags/al.svg';
import AM from './flags/am.svg';
import AO from './flags/ao.svg';
import AR from './flags/ar.svg';
import AS from './flags/as.svg';
import AT from './flags/at.svg';
import AU from './flags/au.svg';
import AW from './flags/aw.svg';
import AZ from './flags/az.svg';
import BA from './flags/ba.svg';
import BB from './flags/bb.svg';
import BD from './flags/bd.svg';
import BE from './flags/be.svg';
import BF from './flags/bf.svg';
import BG from './flags/bg.svg';
import BH from './flags/bh.svg';
import BI from './flags/bi.svg';
import BJ from './flags/bj.svg';
import BM from './flags/bm.svg';
import BO from './flags/bo.svg';
import BR from './flags/br.svg';
import BS from './flags/bs.svg';
import BT from './flags/bt.svg';
import BW from './flags/bw.svg';
import BY from './flags/by.svg';
import BZ from './flags/bz.svg';
import CA from './flags/ca.svg';
import CD from './flags/cd.svg';
import CF from './flags/cf.svg';
import CG from './flags/cg.svg';
import CH from './flags/ch.svg';
import CI from './flags/ci.svg';
import CK from './flags/ck.svg';
import CL from './flags/cl.svg';
import CM from './flags/cm.svg';
import CN from './flags/cn.svg';
import CO from './flags/co.svg';
import CR from './flags/cr.svg';
import CU from './flags/cu.svg';
import CV from './flags/cv.svg';
import CW from './flags/cw.svg';
import CY from './flags/cy.svg';
import CZ from './flags/cz.svg';
import DE from './flags/de.svg';
import DJ from './flags/dj.svg';
import DK from './flags/dk.svg';
import DM from './flags/dm.svg';
import DO from './flags/do.svg';
import DZ from './flags/dz.svg';
import EC from './flags/ec.svg';
import EE from './flags/ee.svg';
import EG from './flags/eg.svg';
import ER from './flags/er.svg';
import ES from './flags/es.svg';
import ET from './flags/et.svg';
import FI from './flags/fi.svg';
import FJ from './flags/fj.svg';
import FK from './flags/fk.svg';
import FM from './flags/fm.svg';
import FO from './flags/fo.svg';
import FR from './flags/fr.svg';
import GA from './flags/ga.svg';
import GB from './flags/gb.svg';
import GD from './flags/gd.svg';
import GE from './flags/ge.svg';
import GG from './flags/gg.svg';
import GH from './flags/gh.svg';
import GI from './flags/gi.svg';
import GL from './flags/gl.svg';
import GM from './flags/gm.svg';
import GN from './flags/gn.svg';
import GQ from './flags/gq.svg';
import GR from './flags/gr.svg';
import GT from './flags/gt.svg';
import GU from './flags/gu.svg';
import GW from './flags/gw.svg';
import HK from './flags/hk.svg';
import HN from './flags/hn.svg';
import HR from './flags/hr.svg';
import HT from './flags/ht.svg';
import HU from './flags/hu.svg';
import ID from './flags/id.svg';
import IE from './flags/ie.svg';
import IL from './flags/il.svg';
import IM from './flags/im.svg';
import IN from './flags/in.svg';
import IO from './flags/io.svg';
import IQ from './flags/iq.svg';
import IR from './flags/ir.svg';
import IS from './flags/is.svg';
import IT from './flags/it.svg';
import JE from './flags/je.svg';
import JM from './flags/jm.svg';
import JO from './flags/jo.svg';
import JP from './flags/jp.svg';
import KE from './flags/ke.svg';
import KG from './flags/kg.svg';
import KH from './flags/kh.svg';
import KI from './flags/ki.svg';
import KM from './flags/km.svg';
import KN from './flags/kn.svg';
import KP from './flags/kp.svg';
import KR from './flags/kr.svg';
import KW from './flags/kw.svg';
import KY from './flags/ky.svg';
import KZ from './flags/kz.svg';
import LA from './flags/la.svg';
import LB from './flags/lb.svg';
import LI from './flags/li.svg';
import LK from './flags/lk.svg';
import LR from './flags/lr.svg';
import LS from './flags/ls.svg';
import LT from './flags/lt.svg';
import LU from './flags/lu.svg';
import LV from './flags/lv.svg';
import LY from './flags/ly.svg';
import MA from './flags/ma.svg';
import MC from './flags/mc.svg';
import MD from './flags/md.svg';
import ME from './flags/me.svg';
import MG from './flags/mg.svg';
import MH from './flags/mh.svg';
import MK from './flags/mk.svg';
import ML from './flags/ml.svg';
import MM from './flags/mm.svg';
import MN from './flags/mn.svg';
import MO from './flags/mo.svg';
import MP from './flags/mp.svg';
import MQ from './flags/mq.svg';
import MR from './flags/mr.svg';
import MS from './flags/ms.svg';
import MT from './flags/mt.svg';
import MU from './flags/mu.svg';
import MV from './flags/mv.svg';
import MW from './flags/mw.svg';
import MX from './flags/mx.svg';
import MY from './flags/my.svg';
import MZ from './flags/mz.svg';
import NA from './flags/na.svg';
import NATO from './flags/nato.svg';
import NE from './flags/ne.svg';
import NF from './flags/nf.svg';
import NG from './flags/ng.svg';
import NI from './flags/ni.svg';
import NL from './flags/nl.svg';
import NO from './flags/no.svg';
import NP from './flags/np.svg';
import NR from './flags/nr.svg';
import NU from './flags/nu.svg';
import NZ from './flags/nz.svg';
import OM from './flags/om.svg';
import PA from './flags/pa.svg';
import PE from './flags/pe.svg';
import PF from './flags/pf.svg';
import PG from './flags/pg.svg';
import PH from './flags/ph.svg';
import PK from './flags/pk.svg';
import PL from './flags/pl.svg';
import PN from './flags/pn.svg';
import PR from './flags/pr.svg';
import PS from './flags/ps.svg';
import PT from './flags/pt.svg';
import PW from './flags/pw.svg';
import PY from './flags/py.svg';
import QA from './flags/qa.svg';
import RO from './flags/ro.svg';
import RS from './flags/rs.svg';
import RU from './flags/ru.svg';
import RW from './flags/rw.svg';
import SA from './flags/sa.svg';
import SB from './flags/sb.svg';
import SC from './flags/sc.svg';
import SD from './flags/sd.svg';
import SE from './flags/se.svg';
import SG from './flags/sg.svg';
import SI from './flags/si.svg';
import SK from './flags/sk.svg';
import SL from './flags/sl.svg';
import SM from './flags/sm.svg';
import SN from './flags/sn.svg';
import SO from './flags/so.svg';
import SR from './flags/sr.svg';
import SS from './flags/ss.svg';
import ST from './flags/st.svg';
import SV from './flags/sv.svg';
import SX from './flags/sx.svg';
import SY from './flags/sy.svg';
import SZ from './flags/sz.svg';
import TC from './flags/tc.svg';
import TD from './flags/td.svg';
import TG from './flags/tg.svg';
import TH from './flags/th.svg';
import TIBET from './flags/tibet.svg';
import TJ from './flags/tj.svg';
import TK from './flags/tk.svg';
import TM from './flags/tm.svg';
import TN from './flags/tn.svg';
import TO from './flags/to.svg';
import TR from './flags/tr.svg';
import TT from './flags/tt.svg';
import TV from './flags/tv.svg';
import TW from './flags/tw.svg';
import TZ from './flags/tz.svg';
import UA from './flags/ua.svg';
import UG from './flags/ug.svg';
import US from './flags/us.svg';
import UY from './flags/uy.svg';
import UZ from './flags/uz.svg';
import VE from './flags/ve.svg';
import VI from './flags/vi.svg';
import VN from './flags/vn.svg';
import VU from './flags/vu.svg';
import WS from './flags/ws.svg';
import YE from './flags/ye.svg';
import ZA from './flags/za.svg';
import ZM from './flags/zm.svg';
import ZW from './flags/zw.svg';
import { ComponentType, SVGAttributes } from 'react';

const FlagIcon: Record<string, ComponentType<SVGAttributes<SVGElement>> | undefined> = {
    ZW: ZW,
    ZM: ZM,
    ZA: ZA,
    YE: YE,
    WS: WS,
    VU: VU,
    VN: VN,
    VI: VI,
    VE: VE,
    UZ: UZ,
    UY: UY,
    US: US,
    UG: UG,
    UA: UA,
    TZ: TZ,
    TW: TW,
    TV: TV,
    TT: TT,
    TR: TR,
    TO: TO,
    TN: TN,
    TM: TM,
    TK: TK,
    TJ: TJ,
    TIBET: TIBET,
    TH: TH,
    TG: TG,
    TD: TD,
    TC: TC,
    SZ: SZ,
    SY: SY,
    SX: SX,
    SV: SV,
    ST: ST,
    SS: SS,
    SR: SR,
    SO: SO,
    SN: SN,
    SM: SM,
    SL: SL,
    SK: SK,
    SI: SI,
    SG: SG,
    SE: SE,
    SD: SD,
    SC: SC,
    SB: SB,
    SA: SA,
    RW: RW,
    RU: RU,
    RS: RS,
    RO: RO,
    QA: QA,
    PY: PY,
    PW: PW,
    PT: PT,
    PS: PS,
    PR: PR,
    PN: PN,
    PL: PL,
    PK: PK,
    PH: PH,
    PG: PG,
    PF: PF,
    PE: PE,
    PA: PA,
    OM: OM,
    NZ: NZ,
    NU: NU,
    NR: NR,
    NP: NP,
    NO: NO,
    NL: NL,
    NI: NI,
    NG: NG,
    NF: NF,
    NE: NE,
    NATO: NATO,
    NA: NA,
    MZ: MZ,
    MY: MY,
    MX: MX,
    MW: MW,
    MV: MV,
    MU: MU,
    MT: MT,
    MS: MS,
    MR: MR,
    MQ: MQ,
    MP: MP,
    MO: MO,
    MN: MN,
    MM: MM,
    ML: ML,
    MK: MK,
    MH: MH,
    MG: MG,
    ME: ME,
    MD: MD,
    MC: MC,
    MA: MA,
    LY: LY,
    LV: LV,
    LU: LU,
    LT: LT,
    LS: LS,
    LR: LR,
    LK: LK,
    LI: LI,
    LB: LB,
    LA: LA,
    KZ: KZ,
    KY: KY,
    KW: KW,
    KR: KR,
    KP: KP,
    KN: KN,
    KM: KM,
    KI: KI,
    KH: KH,
    KG: KG,
    KE: KE,
    JP: JP,
    JO: JO,
    JM: JM,
    JE: JE,
    IT: IT,
    IS: IS,
    IR: IR,
    IQ: IQ,
    IO: IO,
    IN: IN,
    IM: IM,
    IL: IL,
    IE: IE,
    ID: ID,
    HU: HU,
    HT: HT,
    HR: HR,
    HN: HN,
    HK: HK,
    GW: GW,
    GU: GU,
    GT: GT,
    GR: GR,
    GQ: GQ,
    GN: GN,
    GM: GM,
    GL: GL,
    GI: GI,
    GH: GH,
    GG: GG,
    GE: GE,
    GD: GD,
    GB: GB,
    GA: GA,
    FR: FR,
    FO: FO,
    FM: FM,
    FK: FK,
    FJ: FJ,
    FI: FI,
    ET: ET,
    ES: ES,
    ER: ER,
    EG: EG,
    EE: EE,
    EC: EC,
    DZ: DZ,
    DO: DO,
    DM: DM,
    DK: DK,
    DJ: DJ,
    DE: DE,
    CZ: CZ,
    CY: CY,
    CW: CW,
    CV: CV,
    CU: CU,
    CR: CR,
    CO: CO,
    CN: CN,
    CM: CM,
    CL: CL,
    CK: CK,
    CI: CI,
    CH: CH,
    CG: CG,
    CF: CF,
    CD: CD,
    CA: CA,
    BZ: BZ,
    BY: BY,
    BW: BW,
    BT: BT,
    BS: BS,
    BR: BR,
    BO: BO,
    BM: BM,
    BJ: BJ,
    BI: BI,
    BH: BH,
    BG: BG,
    BF: BF,
    BE: BE,
    BD: BD,
    BB: BB,
    BA: BA,
    AZ: AZ,
    AW: AW,
    AU: AU,
    AT: AT,
    AS: AS,
    AR: AR,
    AO: AO,
    AM: AM,
    AL: AL,
    AI: AI,
    AG: AG,
    AF: AF,
    AE: AE,
    AD: AD,
};

export { FlagIcon };
